import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import GuestHeader from '../../../components/desktop/header/GuestHeader';
import Logo from '../../../components/desktop/header/Logo';
import DeliveryStepIndicator from '../../../components/kiosk/DeliveryStepIndicator';

import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { STREET_STORE } from '../../../constants/constant';
import { getStreetFlags } from '../../../refresh/selectors/featureFlagsSelector';

class CartDesktopHeader extends React.Component {
  constructor(){
    super();
  }

  render() {
    const {
      basicInfo = {},
      withDeliveryIndicator = false,
      deliveryIndex = 0,
      cartFooter = false,
      flags,
      newDesignLuxe,
      isRetryPayment,
      isStreet,
    } = this.props;

    return (
      <div className={`main-header ${cartFooter ? 'cartFooter' : ''}`}>
        <header 
        {...(cartFooter && {'role':'region'})}
        >
          {cartFooter ? (
            <div />
          ) : (
            <div>
              <GuestHeader basicInfo={basicInfo} />
              <Logo
                newDesignLuxe={newDesignLuxe}
                isRetryPayment={isRetryPayment}
                isStreetStore={isStreet}
              />
            </div>
          )}

          <div className="header-right">
            {withDeliveryIndicator ? (
              <DeliveryStepIndicator
                withDeliveryIndicator
                currentIndex={deliveryIndex}
                newDesignLuxe={newDesignLuxe}
              />
            ) : (
              <ul>
                <li aria-label="Secure Payments">
                  <span className="ic-secure" />
                  Secure Payments
                </li>
                <li aria-label="Cash on delivery">
                  <span className="ic-cashondelivery" />
                  Cash on delivery
                </li>
                <li aria-label="Assured Quality">
                  <span className="ic-qlty" />
                  Assured Quality
                </li>
                <li aria-label="Easy returns">
                  <span className="ic-easy-return" />
                  Easy returns
                </li>
              </ul>
            )}
          </div>
        </header>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { flags = {} } = state;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const { isThemeEnableWeb } = getStreetFlags(state);

  return {
    newDesignLuxe,
    flags,
    isStreet: isThemeEnableWeb === 'ON' && storeName === STREET_STORE,
  };
};

export default CartDesktopHeader = withRouter(connect(mapStateToProps)(CartDesktopHeader));
